module.exports = __webpack_public_path__ + "static/media/logo_white.1e9b277f.svg";